import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e59f5aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import { PropType } from 'vue';
import Icon from './icon/Icon';
import IconComponent from './icon/IconComponent.vue';

type buttonSizes = 'small' | 'medium' | 'large';
type colorType = 'primary' | 'accent' | 'secondary' | 'tertiary';


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
  rightIconValue: {
    type: Number as PropType<Icon>,
    default: 0
  },
  leftIconValue: {
    type: Number as PropType<Icon>
  },
  size: {
    type: String as PropType<buttonSizes>,
    default: 'small'
  },
  colorType: {
    type: String as PropType<colorType>,
    default: 'primary'
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    "data-testid": "button",
    class: _normalizeClass(["flex items-center py-2 text-sm rounded cursor-pointer focus:outline-none", {
      small: __props.size === 'small',
      medium: __props.size === 'medium',
      large: __props.size === 'large',
      primary: __props.colorType === 'primary',
      secondary: __props.colorType === 'secondary',
      tertiary: __props.colorType === 'tertiary',
      accent: __props.colorType === 'accent',
      disabled: __props.disabled === true
    }]),
    disabled: __props.disabled
  }, [
    (__props.leftIconValue)
      ? (_openBlock(), _createBlock(IconComponent, {
          key: 0,
          icon: __props.leftIconValue,
          class: "mr-2"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (__props.rightIconValue)
      ? (_openBlock(), _createBlock(IconComponent, {
          key: 1,
          icon: __props.rightIconValue,
          class: "ml-2"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})